<template>
  <div
    class="mx-auto p-8 prose prose-sm prose-stone sm:prose-base w-full text-justify !text-black"
    v-html="htmlContent"
  />
</template>

<script>
import { marked } from 'marked'

import { mapState } from 'vuex'

import termsOfServicesEn from '@/markdown/terms-of-services-en.md?raw'
import termsOfServicesUk from '@/markdown/terms-of-services-uk.md?raw'

export default {
  name: 'PublicTermsOfServicesPage',

  computed: {
    ...mapState('locale', ['currentLocale']),

    htmlContent() {
      const text =
        this.currentLocale === 'en' ? termsOfServicesEn : termsOfServicesUk

      return marked(text)
    }
  }
}
</script>
